import(/* webpackMode: "eager" */ "/opt/build/repo/app/changelogs/page.tsx");
